import { createAction } from "@reduxjs/toolkit";

const ACTION_PREFIX = "DYNAMIC_FORM";

export const setSubmittedPageName = createAction<string>(`${ACTION_PREFIX}/SUBMITTED_PAGE_NAME`);
